import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8c492b50"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "menu-list" }
const _hoisted_3 = ["href"]
const _hoisted_4 = { class: "footer" }
const _hoisted_5 = { class: "business-info" }
const _hoisted_6 = /*#__PURE__*/_createTextVNode(" (유)세무법인혜움 ")
const _hoisted_7 = /*#__PURE__*/_createTextVNode(" 대표 이재희 ")
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "break" }, null, -1))
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" 사업자등록번호: 238-81-01904 ")
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" 세무 기장 및 세금 신고 ")
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "break newline" }, null, -1))
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" (주)혜움 ")
const _hoisted_13 = /*#__PURE__*/_createTextVNode(" 대표 옥형석 ")
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "break" }, null, -1))
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" 사업자등록번호: 807-81-00564 ")
const _hoisted_16 = /*#__PURE__*/_createTextVNode(" 세무/회계 Cloud Service ")
const _hoisted_17 = /*#__PURE__*/_createTextVNode(/*#__PURE__*/_toDisplayString(`문의: 카카오톡 채널 @더낸세금`))

import Text from '@/components/common/TextComponent.vue'
import HeumTaxLogo from '@/styles/icon/HeumTaxLogo.vue'
import { getAddress, getKakaoChannelUrl } from '@/constants/address'

import { FooterList } from '../constants/footerList'


export default /*#__PURE__*/_defineComponent({
  name: 'LandingFooter',
  setup(__props) {

const handleKakaoChannelClick = () => {
  window.open(getKakaoChannelUrl(), '_blank')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(FooterList), (item) => {
        return (_openBlock(), _createElementBlock("a", {
          key: item.id,
          class: "menu",
          target: "_blank",
          href: item.url
        }, [
          _createVNode(Text, {
            size: "20px",
            "mobile-size": "14px"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.text), 1)
            ]),
            _: 2
          }, 1024)
        ], 8, _hoisted_3))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(HeumTaxLogo, {
        color: "#000033",
        width: 140,
        height: 31
      }),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(Text, { "mobile-size": "14px" }, {
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        }),
        _createVNode(Text, { "mobile-size": "14px" }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        }),
        _hoisted_8,
        _createVNode(Text, { "mobile-size": "12px" }, {
          default: _withCtx(() => [
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(Text, { "mobile-size": "12px" }, {
          default: _withCtx(() => [
            _hoisted_10
          ]),
          _: 1
        }),
        _hoisted_11,
        _createVNode(Text, { "mobile-size": "14px" }, {
          default: _withCtx(() => [
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(Text, { "mobile-size": "14px" }, {
          default: _withCtx(() => [
            _hoisted_13
          ]),
          _: 1
        }),
        _hoisted_14,
        _createVNode(Text, { "mobile-size": "12px" }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        }),
        _createVNode(Text, { "mobile-size": "12px" }, {
          default: _withCtx(() => [
            _hoisted_16
          ]),
          _: 1
        })
      ]),
      _createVNode(Text, { "mobile-size": "12px" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_unref(getAddress)()), 1)
        ]),
        _: 1
      }),
      _createVNode(Text, {
        class: "pointer",
        "mobile-size": "12px",
        margin: "8px 0 0 0",
        "mobile-margin": "4px 0 0 0",
        "text-decoration": "underline",
        onClick: handleKakaoChannelClick
      }, {
        default: _withCtx(() => [
          _hoisted_17
        ]),
        _: 1
      })
    ])
  ]))
}
}

})